<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.addBlog") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #2f6a68">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Image Upload Input -->
          <base-image-upload-input
            col="12"
            identifier="blog_image"
            :placeholder="$t('PLACEHOLDERS.blogImage')"
            @selectImage="selectImage"
            required
          />
          <!-- End:: Image Upload Input -->

          <!-- Start:: Title Arabic Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.titleAr')"
            v-model.trim="data.title_ar"
            required
          />
          <!-- End:: Title Arabic Input -->

          <!-- Start:: Title English Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.titleEn')"
            v-model.trim="data.title_en"
            required
          />
          <!-- End:: Title English Input -->

          <!-- Start:: Description Arabic Input -->
          <base-input
            col="6"
            rows="3"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descriptionAr')"
            v-model.trim="data.description_ar"
            required
          />
          <!-- End:: Description Arabic Input -->

          <!-- Start:: Description English Input -->
          <base-input
            col="6"
            rows="3"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descriptionEn')"
            v-model.trim="data.description_en"
            required
          />
          <!-- End:: Description English Input -->

          <!-- Start:: Content Arabic Input -->
          <base-text-editor
            col="12"
            :placeholder="$t('PLACEHOLDERS.contentAr')"
            v-model="data.content_ar"
          />
          <!-- End:: Content Arabic Input -->

          <!-- Start:: Content English Input -->
          <base-text-editor
            col="12"
            :placeholder="$t('PLACEHOLDERS.contentEn')"
            v-model="data.content_en"
          />
          <!-- End:: Content English Input -->

          <!-- Start:: Meta Title Arabic Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.metaTitleAr')"
            v-model.trim="data.meta_title_ar"
          />
          <!-- End:: Meta Title Arabic Input -->

          <!-- Start:: Meta Title English Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.metaTitleEn')"
            v-model.trim="data.meta_title_en"
          />
          <!-- End:: Meta Title English Input -->

          <!-- Start:: Meta Description Arabic Input -->
          <base-input
            col="6"
            rows="2"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.metaDescAr')"
            v-model.trim="data.meta_desc_ar"
          />
          <!-- End:: Meta Description Arabic Input -->

          <!-- Start:: Meta Description English Input -->
          <base-input
            col="6"
            rows="2"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.metaDescEn')"
            v-model.trim="data.meta_desc_en"
          />
          <!-- End:: Meta Description English Input -->

          <!-- Start:: Active Switch Input -->
          <div class="input_wrapper switch_wrapper my-5">
            <v-switch
              color="green"
              :label="
                data.is_active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.is_active"
              hide-details
            ></v-switch>
          </div>
          <!-- End:: Active Switch Input -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
export default {
  name: "CreateBlog",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        image: {
          path: null,
          file: null,
        },
        title_ar: null,
        title_en: null,
        description_ar: null,
        description_en: null,
        content_ar: null,
        content_en: null,
        meta_title_ar: null,
        meta_title_en: null,
        meta_desc_ar: null,
        meta_desc_en: null,
        is_active: true,
      },
      // End:: Data Collection To Send
    };
  },

  methods: {
    // Start:: Select Upload Image
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },
    // End:: Select Upload Image

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;

      if (!this.data.image.file) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.image"));
        return;
      } else if (!this.data.title_ar) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.titleAr"));
        return;
      } else if (!this.data.title_en) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.titleEn"));
        return;
      } else if (!this.data.description_ar) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.descriptionAr"));
        return;
      } else if (!this.data.description_en) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.descriptionEn"));
        return;
      } else if (!this.data.content_ar) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.contentAr"));
        return;
      } else if (!this.data.content_en) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.contentEn"));
        return;
      } else {
        this.submitForm();
        return;
      }
    },
    // End:: validate Form Inputs

    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();

      // Start:: Append Request Data
      REQUEST_DATA.append("title[ar]", this.data.title_ar);
      REQUEST_DATA.append("title[en]", this.data.title_en);
      REQUEST_DATA.append("description[ar]", this.data.description_ar);
      REQUEST_DATA.append("description[en]", this.data.description_en);
      REQUEST_DATA.append("content[ar]", this.data.content_ar);
      REQUEST_DATA.append("content[en]", this.data.content_en);

      if (this.data.meta_title_ar) {
        REQUEST_DATA.append("title_seo[ar]", this.data.meta_title_ar);
      }
      if (this.data.meta_title_en) {
        REQUEST_DATA.append("title_seo[en]", this.data.meta_title_en);
      }
      if (this.data.meta_desc_ar) {
        REQUEST_DATA.append("description_seo[ar]", this.data.meta_desc_ar);
      }
      if (this.data.meta_desc_en) {
        REQUEST_DATA.append("description_seo[en]", this.data.meta_desc_en);
      }

      if (this.data.image.file) {
        REQUEST_DATA.append("image", this.data.image.file);
      }
      REQUEST_DATA.append("is_active", +this.data.is_active);
      // End:: Append Request Data

      try {
        await this.$axios({
          method: "POST",
          url: `blogs`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({ path: "/blogs/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form
  },
};
</script>
